var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 h-100 text-center",attrs:{"id":"stream"}},[_c('div',{ref:"player",attrs:{"id":"player"}}),_vm._t("default",null,{"showWaitingMessage":_vm.showWaitingMessage})],2)}
var staticRenderFns = []

export { render, staticRenderFns }